import React from "react";
import { blogs } from "./blogData";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Helmet } from "react-helmet-async";
function BlogList() {
  return (

    <div className="container py-5">
      <Helmet>
        <title>
          AzyByte Technologies Blog | Web Development, AI & Digital Solutions
        </title>

        <meta
          name="description"
          content="Explore AzyByte Technologies blogs on web development, software engineering, AI automation, SEO, digital marketing, and business technology solutions."
        />

        <meta
          name="keywords"
          content="AzyByte Technologies, azybyte, AzyByte, Web Development Blog, AI Automation Blog, Software Development, SEO Tips, AzyByte Nadiad"
        />

        <link
          rel="canonical"
          href="https://www.azybyte.in/blog"
        />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="AzyByte Technologies Blog" />
        <meta property="og:description" content="Latest insights from AzyByte Technologies." />
        <meta property="og:url" content="https://www.azybyte.in/blog" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Blog",
            name: "AzyByte Technologies Blog",
            url: "https://www.azybyte.in/blog",
            publisher: {
              "@type": "Organization",
              name: "AzyByte Technologies",
              url: "https://www.azybyte.in"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "AzyByte Technologies",
            url: "https://www.azybyte.in",
            logo: "https://www.azybyte.in/azybytelogo.png",
            sameAs: [
              "https://linkedin.com/company/azybytetechnologies",
              "https://instagram.com/azybytetech"
            ]
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.azybyte.in"
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blog",
                item: "https://www.azybyte.in/blog"
              }
            ]
          })}
        </script>
      </Helmet>
      <Navbar></Navbar>

      {/* Header */}
      <div className="text-center mb-5 mt-4">
        <h1 className="fw-bold">Blogs – AzyByte Technologies</h1>
      <p className="text-muted mx-auto" style={{maxWidth:"800px"}}>
          Welcome to the AzyByte Technologies blog. We publish expert insights
          on web development, custom software solutions, AI automation,
          cloud technologies, SEO, digital marketing, and business growth
          strategies to help companies succeed online.
      </p>
      </div>

      {/* Blog Grid */}
      <div className="row g-4">

        {blogs.map((blog) => (
          <div key={blog.id} className="col-md-6 col-lg-4">

            <article className="blog-card h-100 shadow-sm rounded overflow-hidden">

              {/* Image */}
              <div className="blog-image">
                <img
                  src={blog.image}
                  alt={`${blog.title} - AzyByte Technologies`}
                  className="blog-img"

                />
              </div>

              {/* Content */}
              <div className="p-3">

                {/* Date */}
                <small className="text-muted">{blog.date}</small>

                {/* Title */}
                <h2 className="h5 mt-2 fw-bold">
                  <Link
                    to={`/blog/${blog.slug}`}
                    className="text-decoration-none text-dark"
                  >
                    {blog.title}
                  </Link>
                </h2>

                {/* Description */}
                <p className="text-muted small">
                  {blog.description}
                </p>

                {/* Tags */}
                <div className="mb-3">
                  {blog.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="badge bg-light text-primary border me-1"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* Button */}
                <Link
                  to={`/blog/${blog.slug}`}
                  className="btn btn-primary btn-sm w-100"
                >
                  Read More →
                </Link>

              </div>
            </article>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogList;